var panoramas = [
  {
    lon: 24.124378,
    lat: 57.028121,
    id: "p1",
    imageUrl: "1",
    title: "Vecmīlgrāvis",
    description:
      "“RĪGAS KUĢU BŪVĒTĀVA” AS te veic kuģu remontus un rūpniecisko ražošanu.",
    index: 0,
  },
  {
    lon: 24.128786,
    lat: 57.026882,
    id: "p2",
    imageUrl: "2",
    title: "Mīlgrāvis",
    description:
      "“VEGA STIVIDORS” SIA, “BALTMARINE TERMINAL” SIA un “BLB BALTIJAS TERMINĀLS” AS šeit pārkrauj ģenerālkravas, lejamkravas un veic rūpniecisko ražošanu. Te atrodas arī muitas noliktavas.",
    index: 1,
  },
  {
    lon: 24.112559,
    lat: 57.02301,
    id: "p3",
    imageUrl: "3",

    title: "Vecmīlgrāvis",
    description:
      "“RĪGAS KUĢU BŪVĒTĀVA” AS te veic kuģu remontus un rūpniecisko ražošanu.",
    index: 2,
  },
  {
    lon: 24.115373,
    lat: 57.020635,
    id: "p4",
    imageUrl: "4",

    title: "Sarkandaugava",
    description:
      "“JAUNMILGRĀVJA OSTAS KOMPĀNIJA” SIA, “VL BUNKERINGS” SIA, “STARTS–RĪGA” AS, “RIKON” AS un “EKO OSTA” SIA šeit pārkrauj beramkravas, ģenerālkravas, lejamkravas, veic rūpniecisko ražošanu un atkritumu apsaimniekošanu. Te atrodas arī muitas noliktavas.",
    index: 3,
  },
  {
    lon: 24.100648,
    lat: 57.02585,
    id: "p5",
    imageUrl: "5",

    title: "Vecmīlgrāvis, Kundziņsala",
    description: "",
    index: 4,
  },
  {
    lon: 24.089674,
    lat: 57.029309,
    id: "p6",
    imageUrl: "6",

    title: "Vecmīlgrāvis",
    description:
      "Te atrodas KUĢU SATIKSMES VADĪBAS CENTRS un RĪGAS BRĪVOSTAS PĀRVALDE. “PORT MILGRAVIS” SIA šeit pārkrauj beramkravas un ģenerālkravas.",
    index: 5,
  },
  {
    lon: 24.080669,
    lat: 57.034007,
    id: "p7",
    imageUrl: "7",

    title: "Vecmīlgrāvis",
    description:
      "“MANGALI SHIPYARD” SIA un “RIGA NORDIC TERMINAL” SIA šeit veic kuģu remontus, pārkrauj beramkravas un ģenerālkravas. Te atrodas arī muitas noliktavas.",
    index: 6,
  },
  {
    lon: 24.073541,
    lat: 57.044178,
    id: "p8",
    imageUrl: "8",

    title: "Vecmīlgrāvis",
    description:
      "“RĪGAS UNIVERSĀLAIS TERMINĀLS” SIA, “ALPHA OSTA” SIA un “CARGO CONCEPT” SIA šeit pārkrauj beramkravas, ģenerālkravas, konteinerus un veic konteineru uzglabāšanu. Te atrodas arī muitas noliktavas.",
    index: 7,
  },
  {
    lon: 24.079732,
    lat: 57.043507,
    id: "p9",
    imageUrl: "9",

    title: "Vecmīlgrāvis",
    description:
      "“NESTE LATVIJA” SIA, “CIRCLE K LATVIJA” SIA, “NAFTIMPEKS” SIA un “JAUNZELTIŅI” SIA šeit pārkrauj lejamkravas, ģenerālkravas un beramkravas.",
    index: 8,
  },
  {
    lon: 24.065381,
    lat: 57.046088,
    id: "p10",
    imageUrl: "10",

    title: "Vecmīlgrāvis",
    description:
      "“RĪGAS UNIVERSĀLAIS TERMINĀLS” SIA un “VLD GRUPA” SIA šeit pārkrauj beramkravas, ģenerālkravas, konteinerus, lejamkravas un veic konteineru uzglabāšanu.",
    index: 9,
  },
  {
    lon: 24.069133,
    lat: 57.048257,
    id: "p11",
    imageUrl: "11",

    title: "Mangaļsala",
    description: "Te atrodas “JAHTKLUBS AUDA”.",
    index: 10,
  },
  {
    lon: 24.05497,
    lat: 57.051354,
    id: "p12",
    imageUrl: "12",

    title: "Mangaļsala",
    description:
      "Bildē redzama “MS-2“ piestātne, kurā tiek veikta kuģu pārkraušana, jo to atļauj dziļums. Šeit “B PORT” SIA un “MT OSTA” SIA pārkrauj beramkravas un ģenerālkravas.",
    index: 11,
  },
  {
    lon: 24.014732,
    lat: 57.065707,
    id: "p13",
    imageUrl: "13",

    title: "Mangaļsalas mols",
    description:
      "Mangaļsala ir pirmā pilsētas daļa, kuru šķērso visi jūras kuģi, ienākot Daugavā – Rīgas brīvostā. Tieši no Mangaļsalas jūrā iestiepjas Mangaļsalas dambis jeb Austrumu mols, kas būvēts laika posmā no 1850. līdz 1861. gadam.",
    index: 12,
  },
  {
    lon: 24.038462,
    lat: 57.058944,
    id: "p14",
    imageUrl: "14",

    title: "Mangaļsala",
    description:
      "Mangaļsala izveidojās, kad Daugava lielos pavasara palos pārrāva lielo Buļļu salu pie tagadējās ietekas. 1567. gadā upe izlauza savu tagadējo ceļu uz jūru. Tās vecā gultne pilnīgi aizsērēja, un ap 1840. gadu izveidojās Mangaļu pussala.",
    index: 13,
  },
  {
    lon: 24.075042,
    lat: 57.03189,
    id: "p15",
    imageUrl: "15",

    title: "Krievu sala",
    description:
      "“RIGA COAL TERMINAL” SIA, “STREK” SIA un “KS TERMINAL” SIA šeit pārkrauj beramkravas un ģenerālkravas. Te atrodas arī muitas noliktavas un pasažieru terminālis.",
    index: 14,
  },
  {
    lon: 24.117155,
    lat: 57.015162,
    id: "p16",
    imageUrl: "16",

    title: "Sarkandaugava",
    description:
      "“OVI” SIA, “WOODISON TERMINAL” SIA un “BMGS” AS šeit pārkrauj lejamkravas un veic rūpniecisko ražošanu. Te atrodas arī muitas noliktavas.",
    index: 15,
  },
  {
    lon: 24.113966,
    lat: 57.005301,
    id: "p17",
    imageUrl: "17",

    title: "Sarkandaugava",
    description:
      "“PARS TERMINĀLS” SIA un “MAN-TESS TRANZĪTS” SIA šeit pārkrauj lejamkravas, ģenerālkravas un beramkravas. Te atrodas arī muitas noliktavas.",
    index: 16,
  },
  {
    lon: 24.097271,
    lat: 57.013045,
    id: "p18",
    imageUrl: "18",

    title: "Kundziņsala",
    description: "“RIGA FERTILIZER TERMINAL” SIA šeit pārkrauj beramkravas.",
    index: 17,
  },
  {
    lon: 24.098209,
    lat: 57.004217,
    id: "p19",
    imageUrl: "19",

    title: "Kundziņsala",
    description:
      "“BALTIC CONTAINER TERMINAL” SIA, “SYSTEMS RECYCLING” SIA un  “RIGA BULK TERMINAL” SIA šeit pārkrauj beramkravas, konteinerus un veic konteineru uzglabāšanu.  Te atrodas arī muitas noliktavas.",
    index: 18,
  },
  {
    lon: 24.09699,
    lat: 56.989399,
    id: "p20",
    imageUrl: "20",

    title: "Kundziņsala",
    description: "Te atrodas “FRIGO BALTIC” SIA un “P&B TERMINAL” SIA.",
    index: 19,
  },
  {
    lon: 24.094739,
    lat: 56.979693,
    id: "p21",
    imageUrl: "21",

    title: "Andrejsala",
    description:
      "“RIGA CONTAINER TERMINAL” SIA un “RĪGAS CENTRĀLAIS TERMINĀLS” SIA šeit pārkrauj beramkravas, ģenerālkravas, konteinerus un veic konteineru uzglabāšanu. Te atrodas arī muitas noliktavas.",
    index: 20,
  },
  {
    lon: 24.093707,
    lat: 56.971381,
    id: "p22",
    imageUrl: "22",

    title: "Andrejsala",
    description:
      "“RIGA CONTAINER TERMINAL” SIA un “RĪGAS CENTRĀLAIS TERMINĀLS” SIA šeit pārkrauj beramkravas, ģenerālkravas, konteinerus un veic konteineru uzglabāšanu. Te atrodas arī muitas noliktavas.",
    index: 21,
  },
  {
    lon: 24.092957,
    lat: 56.957647,
    id: "p23",
    imageUrl: "23",

    title: "Andrejsala",
    description:
      "Te atrodas “RĪGAS PASAŽIERU TERMINĀLS” SIA pasažieru terminālis.",
    index: 22,
  },
  {
    lon: 24.097083,
    lat: 56.957905,
    id: "p24",
    imageUrl: "24",

    title: "Andrejsala, Rīgas centrs",
    description:
      "Te atrodas “RĪGAS PASAŽIERU TERMINĀLS” SIA un “ANDREJOSTAS JAHTKLUBS” pasažieru terminālis.",
    index: 23,
  },
  {
    lon: 24.095208,
    lat: 56.961416,
    id: "p25",
    imageUrl: "25",

    title: "Andrejsala",
    description:
      "Te atrodas “RĪGAS PASAŽIERU TERMINĀLS” SIA pasažieru terminālis.",
    index: 24,
  },
  {
    lon: 24.088173,
    lat: 56.968438,
    id: "p26",
    imageUrl: "26",

    title: "Andrejsala",
    description:
      "“RĪGAS OSTAS ELEVATORS” AS šeit pārkrauj beramkravas un ģenerālkravas.  Te atrodas arī muitas noliktavas.",
    index: 25,
  },
  {
    lon: 24.099991,
    lat: 57.036743,
    id: "p27",
    imageUrl: "27",

    title: "Vecmīlgrāvis",
    description:
      "Te atrodas Augusta Dombrovska kultūras komplekss: Ziemeļblāzmas pils, Proģimnāzija un Burtnieku nams.",
    index: 26,
  },
  {
    lon: 24.014076,
    lat: 57.060648,
    id: "p28",
    imageUrl: "28",

    title: "Daugavgrīvas mols",
    description:
      "Daugavgrīvas mols būvēts no 1881. līdz 1885. gadam kā Komētforta dambja turpinājums, lai nodrošinātu kuģiem brīvu pieeju Rīgas ostā. Mola garums ir 860 metri.",
    index: 27,
  },
  {
    lon: 24.024674,
    lat: 57.057498,
    id: "p29",
    imageUrl: "29",

    title: "Daugavgrīvas bāka",
    description:
      "Pirmo bāku šajā vietā uzbūvēja 1536. gadā, bet pašreizējā bāka uzcēla 1957. gadā. Tā ir cilindriskas formas dzelzsbetona tornis ar baltu zibšņa uguni, kura augstums ir 35 metri virs jūras līmeņa.",
    index: 28,
  },
  {
    lon: 24.023924,
    lat: 57.049289,
    id: "p30",
    imageUrl: "30",

    title: "Daugavgrīva",
    description:
      "“BOLDERĀJAS KUĢU REMONTA RŪPNĪCA” SIA un “WT TERMINAL” SIA kurš pārkrauj beramkravas un ģenerālkravas.",
    index: 29,
  },
  {
    lon: 24.036961,
    lat: 57.051251,
    id: "p31",
    imageUrl: "31",

    title: "Daugavgrīva",
    description: "„LA CON” SIA šeit pārkrauj beramkravas",
    index: 30,
  },
  {
    lon: 24.041276,
    lat: 57.037982,
    id: "p32",
    imageUrl: "32",

    title: "Daugavgrīva – Bolderāja",
    description:
      "Tilts pār Buļļupi, kurš savieno Daugavgrīvu ar Bolderāju. Mīlestības saliņa.",
    index: 31,
  },
  {
    lon: 24.05497,
    lat: 57.041803,
    id: "p33",
    imageUrl: "33",

    title: "Mīlestības saliņa",
    description:
      "Mīlestības saliņa sāka veidoties 19. gs. otrajā pusē līdz ar Daugavas gultni regulējošo dambju izbūvi. Šeit atrodas putnu vērošanas tornis no kura labi pārskatāma Daugavgrīva, Bolderāja un Mangaļsala.",
    index: 32,
  },
  {
    lon: 24.070727,
    lat: 57.034833,
    id: "p34",
    imageUrl: "34",

    title: "Krievu sala",
    description: "„RIGA COAL TERMINAL” SIA pārkrauj beramkravas.",
    index: 33,
  },
  {
    lon: 24.080201,
    lat: 57.027811,
    id: "p35",
    imageUrl: "35",

    title: "Krievu sala",
    description:
      "“STREK” SIA - pārkrauj beramkravas un „KS TERMINAL” SIA pārkrauj beramkravas un ģenerālkravas, šeit atrodas muitas noliktava un pasažieru terminālis.",
    index: 34,
  },
  {
    lon: 24.085453,
    lat: 57.020583,
    id: "p36",
    imageUrl: "36",

    title: "Voleri",
    description:
      "„LATVIJAS PROPĀNA GĀZE” SIA šeit ir muitas noliktavas un pārkrauj lejamkravas",
    index: 35,
  },
  {
    lon: 24.086016,
    lat: 57.014336,
    id: "p37",
    imageUrl: "37",

    title: "Voleri",
    description: "„OSTA LEJASVOLERI” SIA pārkrauj beramkravas un ģenerālkravas",
    index: 36,
  },
  {
    lon: 24.086766,
    lat: 57.007108,
    id: "p38",
    imageUrl: "38",

    title: "Voleri",
    description: "„JP TERMINAL” SIA pārkrauj beramkravas un ģenerālkravas",
    index: 37,
  },
  {
    lon: 24.08761,
    lat: 56.99988,
    id: "p39",
    imageUrl: "39",

    title: "Voleri",
    description:
      "Dabas liegums Krēmeri radīts putnu ligzdošanas vietu aizsardzības nolūkos. „Riga Bulk Terminal” nodarbojas ar beramkravu pārkraušanu. ",
    index: 38,
  },
  {
    lon: 24.086297,
    lat: 56.990587,
    id: "p40",
    imageUrl: "40",

    title: "Spilve",
    description: "„KRS” SIA Šeit veic kuģu remontu",
    index: 39,
  },
  {
    lon: 24.071478,
    lat: 57.01635,
    id: "p41",
    imageUrl: "41",

    title: "Bolderāja",
    description:
      "Hapaka grāvis ir Daugavas kreisā krasta pieteka, kas sākas Babītes mežos un plūst cauri Spilves pļavām. Kopumā grāvis ir 25 kilometrus garš. Izveidojies no vecupes, kas iezīmē seno Lielupes gultni pār Lieknei no Babītes ezera līdz Daugavai, lielākā pieteka Beķera grāvis.",
    index: 40,
  },
  {
    lon: 24.07748,
    lat: 57.020377,
    id: "p42",
    imageUrl: "42",

    title: "Krievu sala",
    description: "Dzelzceļa pievads termināļiem.",
    index: 41,
  },
  {
    lon: 24.065287,
    lat: 57.028844,
    id: "p43",
    imageUrl: "43",

    title: "Krievu sala, Bolderāja",
    description: "„LATVIJAS FINIERIS”",
    index: 42,
  },
  {
    lon: 24.084796,
    lat: 56.976853,
    id: "p44",
    imageUrl: "44",

    title: "Podrags",
    description: "",
    index: 43,
  },
  {
    lon: 24.076918,
    lat: 56.969161,
    id: "p45",
    imageUrl: "45",

    title: "Iļģuciems",
    description:
      "„EXTRON BALTIC” SIA un „PORT MAGNAT” SIA pārkrauj beramkravas, ģenerālkravas. Šeit atrodas muitas noliktava.",
    index: 44,
  },
  {
    lon: 24.08339,
    lat: 56.966631,
    id: "p46",
    imageUrl: "46",

    title: "Ķīpsala",
    description: "Rīgas sporta burāšanas centrs",
    index: 45,
  },
  {
    lon: 24.086672,
    lat: 56.958318,
    id: "p47",
    imageUrl: "47",

    title: "Ķīpsala",
    description: "„PILSĒTAS JAHTKLUBS”",
    index: 46,
  },
];

var isIos = false;
var imagePath = "";
var standalone = window.navigator.standalone,
  userAgent = window.navigator.userAgent.toLowerCase(),
  safari = /safari/.test(userAgent),
  ios = /iphone|ipod|ipad/.test(userAgent);
if (ios) {
  isIos = true;
}
if (isIos || window.screen.width < 600) {
  imagePath = "/pano/small_panoramas/";
} else {
  imagePath = "/pano/";
}

var panellumStrings = {
  loadButtonLabel: "Ielādēt",
  loadingLabel: "Ielādē...",
  bylineLabel: "",
  noPanoramaError: "",
  fileAccessError: "Nav iespējams ielādēt attēlu.",
  malformedURLError: "",
  iOS8WebGLError: "",
  genericWebGLError:
    "Jūsu interneta pārlūks neatbalsta nepieciešamās WebGL funkcijas.",
  textureSizeError: "Ielādētais attēls ir pārāk liels Jūsu ierīcei.",
  unknownError: "Neizdevās ielādēt panorāmu.",
};
panoramas = panoramas.map(function (userData) {
  return {
    type: "equirectangular",
    panorama: imagePath + userData.imageUrl + ".jpg",

    showZoomCtrl: false,
    showFullscreenCtrl: false,
    autoLoad: true,
    autoRotate: 2, //autoRotateSpeed,
    friction: 0.05,
    strings: panellumStrings,
    coordinates: [userData.lon, userData.lat],
    title: userData.title,
    description: userData.description,
  };
});
export default panoramas;
